window.DS24 = window.DS24 || {};

DS24.shipping = (() => {

    /*
    |--------------------------------------------------------------------------
    | CONFIG
    |--------------------------------------------------------------------------
    */

    const FREE_SHIPPING_MIN_PRODUCTS = 3;

    let progressPercent = 0;

    /*
    |--------------------------------------------------------------------------
    | ACTIVE CART
    |--------------------------------------------------------------------------
    */

    function getActiveCartContainer() {

        const carts = document.querySelectorAll(
            '.app_cart_tooltip_container.open'
        );

        if (!carts.length) {
            return null;
        }

        return carts[carts.length - 1];
    }

    /*
    |--------------------------------------------------------------------------
    | PROGRESS BAR
    |--------------------------------------------------------------------------
    */

    function getProgressBar() {

        const cart = getActiveCartContainer();

        if (!cart) {
            return null;
        }

        return cart.querySelector(
            '.free-shipping-progress'
        );
    }

    /*
    |--------------------------------------------------------------------------
    | CREATE
    |--------------------------------------------------------------------------
    */

    function createProgressBar() {

        /*
        |--------------------------------------------------------------------------
        | ALREADY EXISTS
        |--------------------------------------------------------------------------
        */

        const existing = getProgressBar();

        if (existing) {
            return existing;
        }

        /*
        |--------------------------------------------------------------------------
        | CART
        |--------------------------------------------------------------------------
        */

        const cart = getActiveCartContainer();

        if (!cart) {
            return null;
        }

        /*
        |--------------------------------------------------------------------------
        | TARGET
        |--------------------------------------------------------------------------
        */

        const target = cart.querySelector(
            '.app_cart_list'
        );

        if (!target) {
            return null;
        }

        /*
        |--------------------------------------------------------------------------
        | APPEND
        |--------------------------------------------------------------------------
        */

        target.insertAdjacentHTML(
            'beforebegin',
            `
                <div class="free-shipping-progress">

                    <div class="free-shipping-progress__top">

                        <div class="free-shipping-progress__icon">
                            🚚
                        </div>

                        <div class="free-shipping-progress__content">

                            <div class="free-shipping-progress__text"></div>

                            <div class="free-shipping-progress__bar">

                                <div
                                    class="free-shipping-progress__fill"
                                ></div>

                            </div>

                        </div>

                    </div>

                </div>
            `
        );

        return getProgressBar();
    }

    /*
    |--------------------------------------------------------------------------
    | TOTAL PRODUCTS
    |--------------------------------------------------------------------------
    */

    function totalProducts(cart) {

        const freeGiftIds = new Set([
            ...(DS24_CONFIG.freeGiftTiers || []).map(
                gift => Number(gift.id)
            ),
            Number(DS24_CONFIG.freeGiftId || 0),
            711546,
            711279,
        ]);

        return (cart?.items || []).reduce((total, item) => {

            /*
            |--------------------------------------------------------------------------
            | SKIP FREE GIFTS
            |--------------------------------------------------------------------------
            */

            if (
                freeGiftIds.has(
                    Number(item.product_id)
                )
            ) {
                return total;
            }

            return total + Number(
                item.quantity || 0
            );

        }, 0);
    }

    /*
    |--------------------------------------------------------------------------
    | RENDER
    |--------------------------------------------------------------------------
    */

    function render(cart) {

        const total = totalProducts(cart);

        const remaining = Math.max(
            0,
            FREE_SHIPPING_MIN_PRODUCTS - total
        );

        const percent = Math.min(
            100,
            (total / FREE_SHIPPING_MIN_PRODUCTS) * 100
        );

        /*
        |--------------------------------------------------------------------------
        | PROGRESS
        |--------------------------------------------------------------------------
        */

        let progress = getProgressBar();

        if (!progress) {
            progress = createProgressBar();
        }

        if (!progress) {
            return;
        }

        /*
        |--------------------------------------------------------------------------
        | ELEMENTS
        |--------------------------------------------------------------------------
        */

        const text = progress.querySelector(
            '.free-shipping-progress__text'
        );

        const fill = progress.querySelector(
            '.free-shipping-progress__fill'
        );

        /*
        |--------------------------------------------------------------------------
        | TEXT
        |--------------------------------------------------------------------------
        */

        text.innerHTML = remaining > 0
            ? `
                Noch
                <strong>
                    ${remaining}
                </strong>
                Produkte und der Versand in DE ist kostenfrei
            `
            : `
                🚚 Kostenloser Versand in DE freigeschaltet
            `;

        /*
        |--------------------------------------------------------------------------
        | UNLOCKED
        |--------------------------------------------------------------------------
        */

        progress.classList.toggle(
            'unlocked',
            remaining <= 0
        );

        /*
        |--------------------------------------------------------------------------
        | SMOOTH WIDTH ANIMATION
        |--------------------------------------------------------------------------
        */

        fill.style.width = `${progressPercent}%`;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                fill.style.width = `${percent}%`;
                progressPercent = percent;
            });
        });
    }

    /*
    |--------------------------------------------------------------------------
    | HANDLE
    |--------------------------------------------------------------------------
    */

    function handle(cart) {

        requestAnimationFrame(() => {
            render(cart);
        });
    }

    return {
        handle,
    };

})();